import { GET_SECTION_ROLES } from "constants/sectionRoles";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SECTION_ROLES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
